
















































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import {GetTenantInfo} from '../../../api/realTime'
import myTable from '../../../components/table/my-table.vue'
import ECharts from 'vue-echarts'
import walden from '../../../components/charts/themes/walden.json'
import {GetPathWayOfPatientInfo,GetPathWayStatistics} from '../../../api/realTime'

@Component({
    components: {ECharts,myTable}
})
export default class extends AbpBase {
    created(){
        ECharts.registerTheme('ovilia-green', walden);
        this.getSelects()
        this.getData()
    }
    tipShow = true
    option = {}
    queryform = {
        date:null,
        tenantIds:[],
        optType:0,
    }
    tenantOptions = []
    //获取下拉框
    async getSelects(){
        this.tenantOptions = (await GetTenantInfo({})).data
    }
    searchPopShow = false
    tabs:any = [
        {closable:false,key:0,name:'年度报表',date:null,},
    ]
    activeName = `年度报表`
    removeTab(targetName){
        let ri;
        this.tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
                let nextTab = this.tabs[index + 1] || this.tabs[index - 1];
                if (nextTab) {
                    this.activeName = nextTab.name;
                }
                ri = index
            }
        });
        this.tabs.splice(ri,1)
        this.tabChange()
    }
    detail(p:any){
        let name = p.row.date+'详情';
        let tab = this.tabs.find((item:any)=>{return item.name == name})
        if(tab){
            this.activeName = tab.name;
            this.tabChange()
            return false 
        }
        this.tabs.push({
            closable:true,
            key:0,
            name:name,
            date:p.row.date
        })
        this.activeName = name
        this.tabChange()
    }
    tabChange(){
        this.detailList = []
        let tab = this.tabs.find((item:any)=>{return item.name == this.activeName})
        this.getData()
    }
    list = []
    columns = []
    detailList = []
    renderColumns(){
        this.columns = [
            {
                title:'年份',
                key: 'date',
                width:150,
                render:(h:any,p:any)=> {
                    return this.activeName !== '年度报表' ? h('span',p.row.date):h('span',{
                            style:{
                                color:'rgb(64, 158, 255)',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            },
                            on:{
                                'click':()=>{
                                    this.detail(p)
                                }
                            }
                        },p.row.date)
                },
            },
            {
                title: '临时',
                key: 'temp',
                render:(h:any,p:any)=> {
                    return p.row.temp == 0 ? h('span',p.row.temp):h('span',{
                            style:{
                                color:'rgb(64, 158, 255)',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            },
                            on:{
                                'click':()=>{
                                    this.getDetailData(p)
                                }
                            }
                        },p.row.temp)
                },
            },
            {
                title: 'AVF',
                key: 'avf',
                render:(h:any,p:any)=> {
                    return p.row.avf == 0 ? h('span',p.row.avf):h('span',{
                            style:{
                                color:'rgb(64, 158, 255)',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            },
                            on:{
                                'click':()=>{
                                    this.getDetailData(p)
                                }
                            }
                        },p.row.avf)
                },
            },
            {
                title: 'CVC',
                key: 'cvc',
                render:(h:any,p:any)=> {
                    return p.row.cvc == 0 ? h('span',p.row.cvc):h('span',{
                            style:{
                                color:'rgb(64, 158, 255)',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            },
                            on:{
                                'click':()=>{
                                    this.getDetailData(p)
                                }
                            }
                        },p.row.cvc)
                },
            },
            {
                title: 'AVG',
                key: 'avg',
                render:(h:any,p:any)=> {
                    return p.row.avg == 0 ? h('span',p.row.avg):h('span',{
                            style:{
                                color:'rgb(64, 158, 255)',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            },
                            on:{
                                'click':()=>{
                                    this.getDetailData(p)
                                }
                            }
                        },p.row.avg)
                },
            },
        ]
    }
    
    detailColumns = [
        {
            title:'姓名',
            key:'name',
        },
        {
            title:'建立日期',
            key:'date',
        },
        {
            title:'通路类型',
            key:'type',
        },
    ]
    async getData(){
        let active = this.tabs.find((item:any)=>{return item.name == this.activeName})
        this.queryform.date = active.date?active.date+'-01-01':active.date
        let res = await GetPathWayStatistics(this.queryform)
        this.list = res.data
        this.renderColumns()
        this.renderCharts(res.data)
    }
    async getDetailData(p){
        this.detailList = []
        let active = this.tabs.find((item:any)=>{return item.name == this.activeName})
        let data = {
            year:p.row.date.length===4?p.row.date:active.date.split('-')[0],
            month:p.row.date.length===4?null:p.row.date.split('-')[1],
            tenantIds:this.queryform.tenantIds,
            type:p.column.key,
        }
        let res = await GetPathWayOfPatientInfo(data)
        this.detailList = res.data
    }
    renderCharts(data:any){
        let active = this.tabs.find((item:any)=>{return item.name == this.activeName})
        let xAxis = ["临时", "AVF", "CVC", "AVG"]
        this.option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {            
                    type: 'shadow'        
                }
            },
            legend:{
                data:xAxis
            },
            grid: {
                left: '3%',
                right: '3%',
                bottom: '5%',
                top: '20%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data:data.map((v:any)=>{return v.date}),
                    axisTick: {
                        alignWithLabel: true
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                },
            ],
            series:xAxis.map((v:any)=>{
                return {
                    name:v,
                    type: 'line',
                    label: {
                        normal: {
                            show: true,
                            position: 'top',
                            color: '#999999',
                        }
                    },
                    data:this.getValue2(data,v),
                }
            })
        }
    }
    getValue2(data:any,v:any){
        let list = [];
        data.forEach(item => {
            this.columns.forEach((c:any)=>{
                if(v === c.title){
                    list.push(item[c.key])
                }
            })
        });
        return list
    }
    downxlsx(){
        let XLSX = this.$XLSX;
        var xlsxParam = { raw: true };//转换成excel时，使用原始的格式
        let a = document.createElement('div')
        a.innerHTML = document.querySelector("#mytable").outerHTML
        a.innerHTML = a.innerHTML.replace(/详情/g, '');
        var wb = XLSX.utils.table_to_book(a,xlsxParam);//mytable为表格的id名
        var wbout = XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: true,
            type: "array"
        });
        let filename = `${this.activeName}`+".xlsx"
        try {
            this.$FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            filename
            );
        } catch (e) {
            if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
    }
}
